import { render, staticRenderFns } from "./FilterGroup.vue?vue&type=template&id=130e6c21&scoped=true"
import script from "./FilterGroup.vue?vue&type=script&lang=js"
export * from "./FilterGroup.vue?vue&type=script&lang=js"
import style0 from "./FilterGroup.vue?vue&type=style&index=0&id=130e6c21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e6c21",
  null
  
)

export default component.exports